__turbopack_context__.v({
  "root": "alerts-action-module-scss-module__Xxu2fG__root",
});
